import { cloneDeep } from 'lodash';
import { useState } from 'react';
import type { KlaviyoListIdsSelection } from './types';

export const KlaviyoListIdSelector = ({
  klaviyoListIds,
  setKlaviyoListIds,
}: {
  klaviyoListIds: KlaviyoListIdsSelection;
  setKlaviyoListIds: React.Dispatch<
    React.SetStateAction<KlaviyoListIdsSelection>
  >;
}) => {
  const [search, setSearch] = useState('');

  const selectedKlaviyoListIds = klaviyoListIds.selection;

  const MAX_SELECTED_LISTIDS = 5;

  const selectedCheckboxes = selectedKlaviyoListIds.filter(
    (item) => item.selected
  );

  const handleSelect = (item: {
    list_id: string;
    list_name: string;
    selected: boolean;
  }) => {
    setKlaviyoListIds((prev) => {
      const out = cloneDeep(prev);

      const updated = out.selection.find((old) => old.list_id === item.list_id);
      if (
        updated &&
        (selectedCheckboxes.length < MAX_SELECTED_LISTIDS || item.selected)
      ) {
        updated.selected = !!!updated?.selected;
      }
      return out;
    });
  };

  const filteredSelectedKlaviyoListIds = search
    ? selectedKlaviyoListIds?.filter((item) =>
        item.list_name.toLowerCase().includes(search.toLowerCase())
      )
    : selectedKlaviyoListIds;

  return (
    <div>
      <div className="flex items-center justify-between">
        <p className="flex text-black text-opacity-50">Klaviyo Lists:</p>
        <div className="flex items-center justify-end ">
          <p
            className={`${
              selectedCheckboxes.length >= MAX_SELECTED_LISTIDS
                ? 'text-segments-danger'
                : 'text-gray-400'
            }`}
          >
            {selectedCheckboxes.length} of 5 selected
          </p>
        </div>
        <input
          type="text"
          className="w-64 h-6 rounded-lg border-segments-gray"
          placeholder="search"
          value={search}
          onChange={(e) => setSearch(e.target.value)}
        />
      </div>
      <div className="mt-4 overflow-y-auto lg:h-44">
        {filteredSelectedKlaviyoListIds?.map((item) => (
          <div key={item.list_id} className="">
            <input
              name={item.list_id}
              id={item.list_id}
              className="w-4 h-4 mr-2 rounded-sm cursor-pointer focus:ring-0 text-segments-accent-color-1"
              type="checkbox"
              checked={item.selected}
              onChange={() => handleSelect(item)}
            />
            <label htmlFor={item.list_id}>
              <span className="text-xs"> {item.list_name} </span>
            </label>
          </div>
        ))}
      </div>
    </div>
  );
};
